var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientId)?_c('div',{class:{ disabled: _vm.googleLoginLoading },staticStyle:{"cursor":"pointer"},on:{"click":_vm.onClick}},[_c('div',{ref:"googleButtonContainer",style:(_vm.hasSecret && 'pointer-events:none')})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }